/**
 * Authentication Utilities
 * Handles logout and related authentication functions
 */

// Imports
import { getLogoutUrl } from '../config/auth';

// Flag to prevent duplicate logging
let logoutLogged = false;

/**
 * Shared logout function that both the redux saga and axios interceptor can use
 * Ensures logout is only logged once
 */
export const performLogout = (redirectToKeycloak = true) => {
  // If already logged, don't log again
  if (!logoutLogged) {
    logoutLogged = true;
    
    // Get the user info for logging
    let username = 'unknown';
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const userData = JSON.parse(userStr);
        username = userData.preferred_username || userData.email || 'unknown';
      }
    } catch (e) {
      console.error('Error parsing user data', e);
    }

    // Try to log with navigator.sendBeacon (most reliable for page unloads)
    try {
      const token = localStorage.getItem('token') || '';
      const loginTime = localStorage.getItem('auth_login_time');
      let sessionDuration;
      
      if (loginTime) {
        const startTime = new Date(loginTime).getTime();
        const endTime = new Date().getTime();
        sessionDuration = Math.round((endTime - startTime) / 1000);
      }
      
      // Prepare payload
      const payload = {
        level: 'info',
        serviceName: 'cediFE',
        message: {
          action: 'authentication:logout',
          description: 'User logged out',
          username,
          timestamp: new Date().toISOString(),
          sessionDuration,
          userAgent: navigator.userAgent,
          metadata: {
            logType: 'logout'
          }
        }
      };
      
      // Use sendBeacon which works reliably even during page navigation/unload
      const payloadBlob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      const beaconSent = navigator.sendBeacon(`/nodeapi/logs?token=${encodeURIComponent(token)}`, payloadBlob);
      
      // Fallback to fetch if sendBeacon isn't supported or fails
      if (!beaconSent) {
        fetch('/nodeapi/logs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
            // Deliberately omit Authorization header to allow requests with expired tokens
          },
          body: JSON.stringify(payload),
          // Use these options to make the request as fast as possible
          keepalive: true,
          priority: 'high'
        }).catch(() => {
          // Ignore errors - we don't want to block logout
        });
      }
    } catch (e) {
      // Ignore any errors to ensure logout completes
    }
  }
  
  // Rimuovi i dati di autenticazione immediatamente
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('auth_login_time');
  
  // Only redirect if needed (sometimes we just want to clear auth state)
  if (redirectToKeycloak) {
    window.location.href = getLogoutUrl();
  }
};

export default {
  performLogout
};
